import { Fragment, ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { Field, FormSection } from "@atlaskit/form";

import { Link } from "@/components/wpl/link/src";
import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

import { useConsentHubClientConfig } from "../../../analytics/consent-hub/consent-client.tsx";

const privacyPolicyStyle = css({
    p: {
        color: "#42526e",
        a: {
            "&:hover": {
                color: "#000000",
                textShadow: "none",
                textDecoration: "underline"
            }
        }
    }
});

const consentBoxTextStyle = css({
    fontFamily:
        "Charlie Text, -apple-system, system-ui, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "1.5",
    color: "#42526e"
});

/* eslint-disable @typescript-eslint/no-explicit-any */
export const ConsentInfo = (
    setFieldValue: (name: string, value: any) => void
) => {
    const locale = useConsentHubClientConfig();
    const intl = useIntl();
    const privacyLink = useLocalizedHref("/legal/privacy-policy");
    const privacyPolicy = (
        <div css={privacyPolicyStyle}>
            <p>
                <FormattedMessage
                    id={"enterpriseContactSales.privacyPolicy"}
                    defaultMessage={
                        "By submitting this form, I acknowledge receipt of Atlassian's <privacyPolicyLink>Privacy Policy</privacyPolicyLink>."
                    }
                    values={{
                        ...DEFAULT_VALUES,
                        privacyPolicyLink: (text: ReactNode) => (
                            <Link
                                text={text as unknown as string}
                                href={privacyLink}
                                type={"inline"}
                            />
                        )
                    }}
                />
            </p>
        </div>
    );
    const consent = (
        <Field name={"consent"}>
            {({
                fieldProps: { isRequired, isDisabled, isInvalid, ...validProps }
            }) => (
                <Fragment>
                    <input type={"checkbox"} {...validProps} />
                    <label htmlFor={"consent"} css={consentBoxTextStyle}>
                        {intl.formatMessage({
                            id: "enterpriseContactSales.consent",
                            defaultMessage:
                                "Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates."
                        })}
                    </label>
                </Fragment>
            )}
        </Field>
    );
    if (locale.localeRequiresMarketingCommunicationOptIn) {
        return (
            <FormSection>
                <Fragment>
                    {privacyPolicy}
                    {consent}
                </Fragment>
            </FormSection>
        );
    } else {
        setFieldValue("consent", true);
        return (
            <FormSection>
                <Fragment>{privacyPolicy}</Fragment>
            </FormSection>
        );
    }
};
